export const PRODUCT_ASPECT_TYPES = {
  BOX_HORIZONTAL: 'BoxHorizontal',
  BOX_VERTICAL: 'BoxVertical',
  HORIZONTAL: 'Horizontal',
  VERTICAL: 'Vertical',
  SQUARE: 'Square',
}

export const BOX_ASPECT_RATIO_MIN = 1.2
export const BOX_ASPECT_RATIO_MAX = 1.6

export const SHADOW_TYPES = {
  DROP: 'DropShadow',
  AMBIENT: 'AmbientShadow',
  GLOW: 'GlowShadow',
  CONTACT: 'ContactShadow',
}

export const MAIN_SHADOW_CHOICES = [SHADOW_TYPES.DROP, SHADOW_TYPES.AMBIENT, SHADOW_TYPES.GLOW]

export const PLACEMENT_TYPES = {
  FRONT: 'front',
  TOP: 'top',
  FLOAT: 'float',
  CORNER: 'corner',
  LAYER: 'layer',
  STACK: 'stack',
  // PYRAMID: 'pyramid', --Disabled
  // VERTICAL: 'vertical', --Disabled
  // COLLAGE1: 'collage1', --Disabled
  // COLLAGE2: 'collage2', --Disabled
  // COLLAGE3: 'collage3', --Disabled
  STAIRCASE: 'staircase'
}

export const SPECIAL_PLACEMENTS = [PLACEMENT_TYPES.FRONT, PLACEMENT_TYPES.STAIRCASE, PLACEMENT_TYPES.LAYER]


export const DIRECTIONS = {
  NONE: 'none',
  TOP: 'top',
  LEFT: 'left',
  BOTTOM: 'bottom',
  RIGHT: 'right',
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right',
  BOTTOM_LEFT: 'bottom-left',
  FRONT: 'front',
  BEHIND: 'behind',
}
